import { Col, Container, Form, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../common/integrations'
import { IntegrationIcon } from '../../../../../../components/IntegrationIcon'
import { ReactComponent as ZocksIcon } from '../../../../../../assets/ZocksIcon.svg'
import { ContactLinkingRows } from './ContactLinkingRows'
import { Path, useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../schema'
import { useGetSchemaErrors } from '../../schemaErrors'

export interface ContactLinkingProps {
  serviceId: IntegrationServiceId
  zocksObjectName: string
  linkingKey: MappingKey
  linkingKeyIndex?: number
  isDisabled?: boolean
  onChange?: () => void
}

type MappingKey = 'session' | 'task' | 'additionalObjects'

export const ContactLinking: React.FC<ContactLinkingProps> = ({ serviceId, zocksObjectName, linkingKey, linkingKeyIndex, isDisabled = false, onChange }) => {
  const { watch, setValue } = useFormContext<IntegrationSettings>()
  const contactObject = watch(`mappings.contact.objectName` as const)
  const path = linkingKeyIndex !== undefined ? `mappings.${linkingKey}.${linkingKeyIndex}.contactLinks` : `mappings.${linkingKey}.contactLinks`
  const { getErrorOnPath } = useGetSchemaErrors()
  const linkingError = getErrorOnPath(path)

  const rawPath = linkingKeyIndex !== undefined ? `mappings.${linkingKey}.${linkingKeyIndex}.isHousehold` : `mappings.${linkingKey}.isHousehold`
  const objectIsHousehold = rawPath as Path<IntegrationSettings>

  const isHousehold = watch(objectIsHousehold) as boolean | undefined | null

  const onChangeRollUpToHousehold = (checked: boolean) => {
    setValue(objectIsHousehold, checked, { shouldDirty: true, shouldValidate: true })
    onChange?.()
  }

  return (
    <Container className='p-0'>
      <Row className='mb-3'>
        <Col>
          <h4>Contact Linking</h4>
          <p className='zocks-text-gray-600'>
            Link {zocksObjectName} to {getIntegrationDisplayName(serviceId)} {contactObject}.
          </p>
        </Col>
      </Row>
      <Row className='mb-2 fw-bold'>
        <Col className='d-flex align-items-center'>
          <ZocksIcon width='1rem' height='1rem' />
          <span className='ms-2'>ZOCKS FIELD</span>
        </Col>
        <Col className='d-flex align-items-center'>
          <IntegrationIcon serviceId={serviceId} width='1rem' height='1rem' fill='black' />
          <span className='ms-2'>{getIntegrationDisplayName(serviceId).toUpperCase()}</span>
        </Col>
      </Row>
      <ContactLinkingRows serviceId={serviceId} linkingKey={linkingKey} linkingKeyIndex={linkingKeyIndex} isDisabled={isDisabled} onChange={onChange} />
      {linkingError && <div className='invalid-feedback d-block'>{linkingError || 'Incomplete contact linking information'}</div>}
      <Form.Check
        key={rawPath + '.updatable'}
        type='checkbox'
        id={rawPath + '.updatable'}
        label={`Roll up to Household`}
        checked={isHousehold ?? false}
        onChange={(e) => onChangeRollUpToHousehold(e.target.checked)}
        disabled={isDisabled}
      />
    </Container>
  )
}
